import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chart-progress-main" }
const _hoisted_2 = { class: "chart-progress" }

import { ref, computed, onMounted, reactive } from 'vue'
import VueApexCharts from 'vue3-apexcharts'


export default /*@__PURE__*/_defineComponent({
  __name: 'ChartProgress',
  props: {
    size: { default: 130 },
    series: { default: () => [75] },
    labelColor: { default: '#2699fb' },
    label: { default: '24/40' },
    subLabel: { default: '' },
    labelShow: { type: Boolean, default: true },
    subLabelShow: { type: Boolean, default: true },
    chartColor: { default: '#2699fb' },
    trackColor: { default: '#2699fb' },
    stylePosition: { default: 'default' },
    fontSizeLabel: { default: '10px' },
    fontSizeValue: { default: '15px' },
    labelOffsetY: { default: 0 },
    subLabelOffsetY: { default: 0 },
    trackOpacity: { default: 0.5 }
  },
  setup(__props: any) {

const props = __props

// Computed property to sanitize series values
const safeSeries = computed(() => {
  if (!props.series || !Array.isArray(props.series)) {
    return [0]
  }
  return props.series.map(val => {
    const num = Number(val)
    if (isNaN(num) || !isFinite(num) || num < 0) {
      return 0
    }
    return Math.min(100, num) // Cap at 100 for radialBar
  })
})

// Computed property to ensure size is valid
const safeSize = computed(() => {
  const num = Number(props.size)
  if (isNaN(num) || !isFinite(num) || num <= 0) {
    return 130 // Default size
  }
  return num
})

const format = () => {
  return props.subLabel
}

const chartOptions = reactive({
  chart: {},
  plotOptions: {
    radialBar: {
      hollow: {
        margin: 0,
        size: '70%',
        position: 'front'
      },
      track: {
        strokeWidth: '90%',
        background: props.trackColor,
        margin: 0,
        opacity: props.trackOpacity,
        dropShadow: {
          enabled: true,
          top: -3,
          left: 0,
          blur: 4,
          opacity: 0.35
        }
      },
      dataLabels: {
        name: {
          show: props.labelShow,
          color: props.labelColor,
          fontSize: props.fontSizeValue,
          offsetY: props.labelOffsetY
        },
        value: {
          formatter: format,
          color: props.labelColor,
          fontSize: props.fontSizeLabel,
          show: props.subLabelShow,
          offsetY: props.subLabelOffsetY
        }
      }
    }
  },
  colors: [props.chartColor],
  stroke: {
    lineCap: 'round'
  },
  labels: [props.label],
  value: '100'
})

const chartStyles = computed(() => ({
  width: safeSize.value - 50 + 'px',
  height: safeSize.value - 50 + 'px'
}))

const chartReady = ref(false)

onMounted(() => {
  setTimeout(() => {
    chartReady.value = true
  }, 100)
})

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([{ 'chart-style-right': __props.stylePosition === 'right', 'chart-style-fixed': __props.stylePosition === 'fixed' }, "chart-content"])
      }, [
        (chartReady.value)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "radialBar",
              height: safeSize.value,
              width: safeSize.value,
              options: chartOptions,
              series: safeSeries.value
            }, null, 8 /* PROPS */, ["height", "width", "options", "series"]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ])
  ]))
}
}

})